export enum EPercentIsEmpty {
	NotEmpty = 'NotEmpty',
	Empty = 'Empty',
}

export const PERCENT_IS_EMPTY_LABEL_MAP: Record<EPercentIsEmpty, string> = {
	[EPercentIsEmpty.NotEmpty]: `percent_is_empty.${EPercentIsEmpty.NotEmpty}`,
	[EPercentIsEmpty.Empty]: `percent_is_empty.${EPercentIsEmpty.Empty}`
}